  <div class="ion-content">
    <div slot="start" class="logo-container">
      <span class="flex-row unset-cursor">
        <span class="logo"></span>
        <span class="logo-text">
          <p class="h1">Promo</p>
          <p class="h1">Portal</p>
        </span>
      </span>
    </div>

    <form *ngIf="!inputDisplay; else errorMessage"
          [formGroup]="resetPassForm"
          (submit)="onSubmit()"
          autocomplete="off"
          class="auth-content">

      <ion-text class="title">
      <span class="fadeIn delay-0s8">
        Click in a field for password tips
      </span>
      </ion-text>

      <div class="input-wrapper">
        <ion-item class="item fadeInRight delay-0s3">
          <div class="input-container">
            <ion-input formControlName="password"
                       name="password"
                       type="{{typePass}}"
                       [placeholder]="'Password'"
                       class="input"
                       clearOnEdit="false">
            </ion-input>
            <button *ngIf="!showPass"
                    type="button"
                    ion-button clear
                    (click)="showPassword()"
                    class="button">
              <i class="fas fa-eye-slash icon invert-icon"></i>
            </button>
            <button *ngIf="showPass"
                    type="button"
                    ion-button clear
                    (click)="showPassword()"
                    class="button">
              <i class="fas fa-eye icon invert-icon"></i>
            </button>
          </div>
        </ion-item>
        <div class="rules">
          <strong>Required:</strong>
          <ul>
            <li *ngFor="let errorMsg of validationMessages.password" [ngClass]="getValidClass('password', errorMsg.type)">
              {{errorMsg.message}}
            </li>
          </ul>
        </div>
      </div>

      <div class="input-wrapper">
        <ion-item class="item fadeInLeft delay-0s5" [ngClass]="getValidClass('rePassword', 'passwordCompare')">
          <div class="input-container">
            <ion-input formControlName="rePassword"
                       name="rePassword"
                       type="{{typeRePass}}"
                       [placeholder]="'Re-Enter Password'"
                       class="input"
                       clearOnEdit="false">
            </ion-input>
            <button *ngIf="!showRePass"
                    type="button"
                    ion-button clear
                    (click)="showRePassword()"
                    class="button">
              <i class="fas fa-eye-slash icon invert-icon"></i>
            </button>
            <button *ngIf="showRePass"
                    type="button"
                    ion-button clear
                    (click)="showRePassword()"
                    class="button">
              <i class="fas fa-eye icon invert-icon"></i>
            </button>
          </div>
        </ion-item>
        <div class="rules">
          <strong>Required:</strong>
          <ul>
            <li class='error'>
              Must re-type password to ensure correctness
            </li>
          </ul>
        </div>
      </div>

      <div class="input-wrapper z-0">
        <ion-item class="item z-0">
          <ion-buttons justify-content-center class="buttons fadeIn delay-0s9">
            <ion-button shape="round"
                        class="clear-button"
                        (click)="clearFields()">
              <i class="fas fa-sync icon"></i>
              Clear
            </ion-button>

            <ion-button type="submit"
                        shape="round"
                        [disabled]="resetPassForm.invalid"
                        class="submit-button">
              <i class="fas fa-check-circle icon"></i>
              Submit
            </ion-button>
          </ion-buttons>
        </ion-item>
      </div>
    </form>

    <ng-template #errorMessage>
      <div class="auth-content">
        <ng-container *ngIf="resetError$ | async as resetError">
          <ion-text class="title">
      <span *ngIf="!resetError?.resetErrorMessage"
            class="fadeIn delay-0s3">Your password has been successfully reset!</span>
            <span *ngIf="!!resetError?.resetErrorMessage"
                  class="fadeIn delay-0s3">{{resetError?.resetErrorMessage}}</span>
          </ion-text>

          <div *ngIf="!resetError?.resetErrorMessage" class="input-wrapper">
            <ion-item class="item">
              <ion-buttons justify-content-center class="buttons fadeIn delay-0s9">
                <ion-button type="submit"
                            shape="round"
                            class="submit-button fadeIn delay-0s5"
                            (click)="redirectToLogin()">
                  <i class="fas fa-sign-in-alt icon"></i>
                  Click Here to Login
                </ion-button>
              </ion-buttons>
            </ion-item>
          </div>
        </ng-container>

      </div>
    </ng-template>

    <div class="sony-music-logo fadeIn delay-1s"></div>
  </div>
